import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IEnvoiDuNetCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class EnvoiDuNetCredentialsStore implements ICredentialsStore {
    private _changes: IEnvoiDuNetCredentialsModel = {} as IEnvoiDuNetCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiUsername() { return this._changes.api_username; };
    public get internalName() { return this._changes.internal_name; };
    public get apiPassword() { return this._changes.api_password; };
    public get siteId() { return this._changes.site_id; };
    public get baseApiUrl() { return this._changes.base_api_url; };

    public get tmsApiAccount() { return this._changes.tms_api_account; };
    public get tmsApiKey() { return this._changes.tms_api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };

    setApiUsername(value: string) {
        this._changes.api_username = value;
    };

    setApiPassword(value: string) {
        this._changes.api_password = value;
    };

    setSiteId(value: string) {
        this._changes.site_id = value;
    };

    setBaseApiUrl(value: string) {
        this._changes.base_api_url = value;
    };

    setTmsApiAccount(value: string) {
        this._changes.tms_api_account = value;
    };

    setTmsApiKey(value: string) {
        this._changes.tms_api_key = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default EnvoiDuNetCredentialsStore;
